import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import * as Endpoints from "../../entities/Endpoints";

export const getClientList = createAsyncThunk(
  "clients/getClientList",
  async ({ coachId, page, pageSize, appliedFilter }, { rejectWithValue }) => {
    try {
      let url = `${Endpoints.GET_CLIENTS}/${coachId}?&PageNumber=${page}&pageSize=${pageSize}`;
      if (appliedFilter) {
        url += `&filter=${appliedFilter}`;
      }
      const response = await axiosInstance.get(url);

      if (!response.data.success) {
        return rejectWithValue(response.data.message);
      }
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error?.data?.message);
    }
  }
);

const clientListSlice = createSlice({
  name: "clientList",
  initialState: {
    clientList: [],
    totalCount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClientList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getClientList.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg.page === 1) {
          state.clientList = action.payload.clients;
          state.totalCount = action.payload.totalCount;
          state.error = null;
        } else {
          state.clientList = [...state.clientList, ...action.payload.clients];
        }
      })
      .addCase(getClientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default clientListSlice.reducer;
